import { BookingSlotApi } from "@models/services/booking";
import { KioskDeviceInfo } from "@models/services/kiosk";
import { resolveApiUrl } from "@utils/apiUrlResolver.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function configureKiosk(
  kioskId: string,
  kioskDeviceInfo: KioskDeviceInfo
) {
  return await apiCall.post(
    API_URL.KIOSK.CONFIGURE,
    {
      kioskDeviceId: kioskDeviceInfo.visitorId,
      kioskDeviceParameters: kioskDeviceInfo.components,
      kioskId,
    },
    undefined,
    "v2"
  );
}

export async function getOrganisationInfo() {
  return await apiCall.get(
    API_URL.KIOSK.ORGANISATION_INFO,
    undefined,
    {},
    "v2"
  );
}

export async function loginKioskUser(profile: string, pin: string) {
  return await apiCall.post(
    API_URL.KIOSK.LOGIN,
    {
      pin,
      profile,
    },
    undefined,
    "v2"
  );
}

export async function getKioskBookingSlot({
  bookingDate,
  isAuthenticated,
  locationId,
}: BookingSlotApi) {
  const apiUrl = resolveApiUrl("/resources/", {
    isAuthenticated,
    kioskPublicUrl: API_URL.KIOSK.BOOKING_SLOT_PUBLIC,
    kioskUrl: API_URL.KIOSK.BOOKING_SLOT,
  });

  return await apiCall.get(
    `${apiUrl}${locationId}?bookingDate=${bookingDate}`,
    undefined,
    {},
    "v2"
  );
}

export async function checkConnectivity(signal: AbortSignal) {
  return await apiCall.get(
    API_URL.KIOSK.CHECK_CONNECTIVITY,
    undefined,
    {},
    "v2",
    signal
  );
}

export async function checkUserPin(profile: string) {
  return await apiCall.post(
    API_URL.KIOSK.CHECK_USER_PIN,
    {
      profile,
    },
    undefined,
    "v2"
  );
}

export async function getLandingPage() {
  return await apiCall.get(API_URL.KIOSK.LANDING_PAGE, undefined, {}, "v2");
}
